import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnChanges, OnInit, QueryList, Renderer2, SimpleChanges, ViewChildren} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {GlobalQuestionService} from '../../services/global-question.service';
import {slideInRightOnEnterAnimation, slideOutLeftOnLeaveAnimation} from 'angular-animations';
import { UserStore } from 'src/app/modules/authentication/state/user.store';
import { scrollToItem } from '../../utilities';
import { QuestionFlowSessionQuery } from '../../questions/state/question-flow-session.query';
import { AnimationOptions } from 'ngx-lottie';
import { API_PATH, RouterLinks } from '../../constants';
import { QuestionFlowSessionStore } from '../../questions/state/question-flow-session.store';
import { PolicyService } from 'src/app/modules/policy/services/policy.service';
import { PolicyQuery } from 'src/app/modules/policy/state/policy.query';
import { ComponentsService } from '../../services/components-service';
import { interval, Observable, of, Subject, Subscription } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, debounceTime, distinctUntilChanged, finalize, switchMap, takeWhile } from 'rxjs/operators';
import { d } from '@datorama/akita-ngdevtools';
import { FlowPlayerService } from '../../services/flow-player.service';
import { Question } from '../../models/underwriter.model';
import { environment } from 'src/environments/environment';


declare const Dropzone: any;
declare const dropzonePreviewTemplate: any;
declare var noUiSlider: any;
declare var wNumb: any;
declare const $: any;
enum Status {
  Review = '1',
  Missing = '2',
  Conflict = '3'
}
@Component({
    selector: 'app-evi',
    templateUrl: './evi.component.html',
    styleUrls: ['./evi.component.scss'],
    animations: [
        slideInRightOnEnterAnimation({ duration: 600 }),
        slideOutLeftOnLeaveAnimation()
    ],
    standalone: false
})
export class EviComponent implements OnInit, AfterViewInit, OnChanges {
private answerChangeSubject = new Subject<any>();
@ViewChildren('itemTrigger') itemTriggers!: QueryList<ElementRef>;
  private subscription!: Subscription;
  public readonly Status = Status;
  dropZone: any;
  chats = [];
  sessionDetails: any
  index = 1;
  person: any;
  class = '';
  options: AnimationOptions = {
    path: 'assets/evi-icon.json',
  };
  termsAccepted = false;
  uploadDisclaimerAccepted = false;
  showUploadSection = false;
 policy: any;
  eviSessionId = null;
  savedResources: any[] = [];
  uploadInProgress = false;
  // _eviInitialized indicates whether initEvi has already run (prevents double-init)
  private _eviInitialized: boolean = false;
  // _eviApi holds the public API returned by initEvi
  private _eviApi: any = null;
  // track bound listeners so they can be cleaned up if needed
  private _eviBoundListeners: Array<{ target: any; type: string; listener: any; }> = [];
  baseurl = API_PATH.UPLOAD_RESOURCE + '/';
  jobId = '';
  jobStatus: any = null;
  pollingSubscription: Subscription | undefined;
  pdfPasswordRequired = false;
  pdfPasswordInvalid = false;
  pdfPasswordVisible = false;
  pdfPassword = '';
  pdfPasswordAttempts = 0;
  pdfPasswordMessage = '';
  private pdfPendingFile: any = null;
  readonly PDF_PASSWORD_MAX_ATTEMPTS = 0; // 0 = unlimited
  private eviCommandSubscription: Subscription | undefined;
  private routerEventsSubscription: Subscription | undefined;
 questions: any;
  classes: any;
  selectedDetail: any;
  modalButton = {disabled: true, text: 'Continue to quote'};
  mainMenu = true;
  step = 1;
  conflicting = true;
  missing = true;
  review = true;
  class_id: number;
  item_id: string;
  currentStatus: string;
  private originalAnswers: Map<any, any> = new Map();
  // Polling interval in milliseconds (5 seconds)
  private readonly POLLING_INTERVAL = 5000;
  AIModalContent: HTMLElement;
  AIModalBackdrop: HTMLElement;
  demoAIModalNav: HTMLElement;
  demoAIContentQuestions: HTMLElement;
  demoAIContentEdit: HTMLElement;
  demoConflictingInfoBtn: HTMLElement;
  demoReviewInfoBtn: HTMLElement;
  demoSidebarInfoNav: HTMLElement;
  demoSidebarReviewNav: HTMLElement;
  demoConflictingItemsNav: HTMLElement;
  demoMissingItemsNav: HTMLElement;
  reviewDetailsNav: HTMLElement;
  reviewInsuredItemsNav: HTMLElement;
  demoAIBackBtn: HTMLElement;
  demoAITrayBtn: HTMLElement;
  itemQuestions: any;
  pageInfo: any;
  dependentQuestions: Question[] = [];
  currentQuestion: Question;
  answeredQuestions: Question[] = [];
  processing = false;
  activeDependentQuestionId: number = -1;
  pendingDependentQuestion: Question;
  pendingDependentOriginalAnswer: string;
  dependentFlowActive = false;
  dependentFlowDone = false;
  itk = '';

  constructor(
    public router: Router,
    private cdr: ChangeDetectorRef,
    private userStore: UserStore,
    private policyQuery: PolicyQuery,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
    private questionFlowSessionStore: QuestionFlowSessionStore,
    public questionService : GlobalQuestionService,
    private componentsService: ComponentsService,
    private http: HttpClient,
    private flowPlayer: FlowPlayerService
  ) {
    //this.questionService.spinner(true);
    this.person = this.userStore.getValue();
    this.policy = this.policyQuery.getActive();
    this.questionFlowSessionQuery.select('session_id' as any).subscribe((session_id: string) => {
      if (session_id) this.eviSessionId = session_id;
    });
    this.componentsService.getTermsAccepted().subscribe(terms => {
    
      this.termsAccepted = terms.terms;
      if (!this.eviSessionId) {
        const date = new Date();
        this.eviSessionId = date.getTime().toString();
        this.setEviSessionCookie(this.eviSessionId);
      }
      this.index++;
      if (this.chats.length === 0) {
        this.chats.push({
          chat_id: 0,
          chat_index: this.index,
          session_id: this.eviSessionId,
          chat_type: "response",
          chat_text: "Hi, I’m Evi. I’m here to help you find the perfect insurance for your needs. If you have a current policy schedule, or multiple, you can upload them here for me to review and help streamline your quote process.",
          avatar: "",
          file_path: '',
          chat_user: "Evi"
        })
      }
    })
    
  }

  ngOnInit(): void {
    //this.sessionDetails = this.questionFlowSessionQuery.getValue();
    this.eviSessionId = this.getEviSessionCookie();

    if (this.eviSessionId && this.eviSessionId !== ''){
     const parameters = new Map<string, string>();
      parameters.set('session_id', this.eviSessionId);
      this.questionService.runCommandNew(`[getChats]`, parameters).subscribe((chats) => {
        this.chats = chats;
        if (this.chats.length > 0) {
          this.index = this.chats[this.chats.length - 1].chat_index + 1;
          this.termsAccepted = true;
          
        }

      })
    }
    this.subscription = this.answerChangeSubject.pipe(
      // Wait for 500ms pause after the last event
      debounceTime(500), 
      // Ensure the value has actually changed before proceeding
      //distinctUntilChanged()
      distinctUntilChanged((prev, curr) => prev.answer !== curr.answer)
    ).subscribe(answerValue => {
      // 3. This function runs ONLY when the user stops typing
      this.questionResponse(answerValue);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {

  }
  setEviSessionCookie(sessionId): void {
    //const sessionId = 'ABC123';
    const expires = new Date();
    expires.setDate(expires.getDate() + 1);
    expires.setHours(0, 0, 0, 0); 
    document.cookie = `eviSessionId=${sessionId}; expires=${expires.toUTCString()}; path=/; Secure`;
  }

  getEviSessionCookie(): string | null {
    const match = document.cookie.match(new RegExp('(^| )eviSessionId=([^;]+)'));
    return match ? match[2] : null;
  }
  ngAfterViewInit(): void {
    this.initEvi();
    // Apply initial state immediately — the initial NavigationEnd has already fired
    // before this subscription is set up, so checkEviState would never run otherwise.
    try {
      const currentUrl = this.router.url;
      if (
        currentUrl.includes('policy-statement') ||
        currentUrl.includes('login') ||
        currentUrl.includes('policy-quote') ||
        currentUrl.includes('schedule') ||
        currentUrl === '/'
      ) {
        this.initEvi().eviDisable();
      } else {
        this.checkEviState({ url: currentUrl });
      }
    } catch (err) { /* ignore */ }
    // subscribe to router events and handle navigation centrally
    this.routerEventsSubscription = this.router.events.subscribe(this.handleRouterEvent.bind(this));
    // listen for external Evi commands and dispatch to the canonical initEvi API
    try {
      this.eviCommandSubscription = this.componentsService.getEviCommands().subscribe((cmd: string) => {
        try {
          const api = this.initEvi();
          if (!api) return;
          switch ((cmd || '').toLowerCase()) {
            case 'expand':      
              if (typeof api.eviExpand === 'function') api.eviExpand();
              break;          
            case 'close':
              if (typeof api.eviClose === 'function') api.eviClose();
              break;
            case 'minimize':          
              if (typeof api.eviMinimize === 'function') api.eviMinimize();
              break;
            case 'disable':          
              if (typeof api.eviDisable === 'function') api.eviDisable();
              break;
            default:
              // unknown command
              break;
          }
        } catch (err) { /* ignore command errors */ }
      });
    } catch (err) { /* ignore */ }

    // Revert answer if dependent flow modal is dismissed without confirming
    $('#evi-modal-additional').on('hidden.bs.modal', () => {
      if (this.pendingDependentQuestion) {
        this.cancelDependentFlow();
      }
    });
  }
  
  /**
   * Central router event handler. Called for every Router event via subscription in ngAfterViewInit.
   * Extracted so other callers can reuse or tests can invoke it.
   */
  private handleRouterEvent(ev: any): void {
    if (ev instanceof NavigationEnd) {

      if(ev.url.includes('policy-statement') 
        || ev.url.includes('login')          
        || ev.url.includes('policy-quote')
        || ev.url.includes('schedule')      
        || ev.url === '/'
      ){
          try { this.initEvi().eviDisable(); } catch (err) { /* ignore */ }

        return;

      } else {

        const evi = document.querySelector('.evi') as HTMLElement;

        // adjust variable bottom tray offset for specific pages, add more as needed
        if(ev.url.includes(RouterLinks.QuestionFlow)){
          evi.style.setProperty('--evi-tray-offset', `70px`);
        } else {
          evi.style.setProperty('--evi-tray-offset', `0px`);
        }

        try {
              
          this.checkEviState(ev);
        }
        catch (ex) {
          try { this.initEvi().eviClose(); } catch (err) { /* ignore */ }
        }
      }
    }
    // used to testing - can be removed once verified
    //this.initAIModal(null, 'conflicting-info');
  }
  initEvi(): any {
    // toggle evi 
    // Make init idempotent: if already initialized, return cached api
    if (this._eviInitialized) {
      return this._eviApi;
    }
    this._eviInitialized = true;
    const self = this;
    const desktopEviBreakpoint = 992;
    const evi = document.querySelector('.evi');
    $(evi).removeAttr('style');
    const eviSubmit = document.querySelector('#evi-submit');
    const eviInputWrap = document.querySelector('#evi-inputwrap');
    const eviThinking = document.querySelector('#evi-thinking');
    const eviTyping = document.querySelector('#evi-typing');
    const eviTags = document.querySelector('#evi-tags'); 
    const eviBackdrop = document.querySelector('.evi-backdrop');
    const eviInput = document.querySelector<HTMLInputElement>('#evi-input');




    // If Evi is already minimized at first render, initialize draggable immediately (desktop only)
    try {
      if (evi && evi.classList.contains('evi--min') && window.innerWidth >= desktopEviBreakpoint) {
        try { eviDraggable(); } catch (err) { /* ignore */ }
      }
    } catch (err) { /* ignore */ }

    const eviClose = () => {

      // if closing from a max state
      if (evi?.classList.contains('evi--max')) {
        evi.classList.add('evi--close-from-max');
        setTimeout(() => {
          evi.classList.remove('evi--close-from-max');
        }, 500);
      }

      evi?.classList.remove('evi--max');
      evi?.classList.remove('evi--min');
      evi?.classList.add('evi--closed');
      

      eviBackdrop?.classList.remove('is-active');

      // reset evi position
      try { (evi as HTMLElement).style.removeProperty('bottom'); } catch (err) { /* ignore */ }
      try { (evi as HTMLElement).style.removeProperty('left'); } catch (err) { /* ignore */ }
      try { (evi as HTMLElement).style.removeProperty('right'); } catch (err) { /* ignore */ }

      
      document.querySelector('#evi-trigger')?.classList.remove('d-none');
      document.querySelector('#evi-trigger-mobile')?.classList.remove('d-none');

      // only show reminder tooltip once, based on sessionStorage cookie
      if (!sessionStorage.getItem('eviTooltipReminder')) {
        showEviTooltip('Here if you need me');
        sessionStorage.setItem('eviTooltipReminder', 'true');
      }     

      localStorage.setItem('eviState', 'closed');
    };


    const eviDisable = () => {
      evi?.classList.remove('evi--max');
      evi?.classList.remove('evi--min');
      evi?.classList.add('evi--closed');
   

      document.querySelector('#evi-trigger')?.classList.add('d-none');     
      document.querySelector('#evi-trigger-mobile')?.classList.add('d-none');  

      eviBackdrop?.classList.remove('is-active');

      // reset evi position
      try { (evi as HTMLElement).style.removeProperty('bottom'); } catch (err) { /* ignore */ }
      try { (evi as HTMLElement).style.removeProperty('left'); } catch (err) { /* ignore */ }
      try { (evi as HTMLElement).style.removeProperty('right'); } catch (err) { /* ignore */ }
      
      
    };

    const eviExpand = () => {
      // add pointer-events: none so that the backdrop doesn't trigger a close if maximize double-clicked
      (eviBackdrop as HTMLElement)?.style.setProperty('pointer-events', 'none');
      
      setTimeout(() => {
        document.querySelector('#evi-trigger')?.classList.add('d-none');
        document.querySelector('#evi-trigger-mobile')?.classList.add('d-none');

        // remove style property after animation
        (eviBackdrop as HTMLElement)?.style.removeProperty('pointer-events');
      }, 500);

      evi?.classList.remove('evi--min');
      evi?.classList.add('evi--max');
      evi?.classList.remove('evi--closed');

      eviBackdrop?.classList.add('is-active'); 

      scrollChatToBottom();

      try { if (matchMedia('(pointer:fine)').matches) eviInput?.focus(); } catch {}

      localStorage.setItem('eviState', 'expanded');
    };

    const eviMinimize = () => {
      // on mobile, close evi instead of minimizing
      if(window.innerWidth < desktopEviBreakpoint) {        
        eviClose();
        return;
      }

      eviBackdrop?.classList.add('is-active');

      setTimeout(() => {
        document.querySelector('#evi-trigger')?.classList.add('d-none');
        document.querySelector('#evi-trigger-mobile')?.classList.add('d-none');
      }, 500);      

      evi?.classList.remove('evi--max');
      evi?.classList.add('evi--min');
      evi?.classList.remove('evi--closed');

      eviBackdrop?.classList.add('is-active');

      // init draggable (desktop only)
      if (window.innerWidth >= desktopEviBreakpoint) {
        const onTransitionEnd = () => { evi?.removeEventListener('transitionend', onTransitionEnd); eviDraggable(); };
        evi?.addEventListener('transitionend', onTransitionEnd);
        try { this._eviBoundListeners.push({ target: evi, type: 'transitionend', listener: onTransitionEnd }); } catch (err) { /* ignore */ }
      }

      if (eviInput) eviInput.blur();

      localStorage.setItem('eviState', 'minimized');
    };    

    const eviMinMaxToggle = (ev?: Event) => {    
      const panel = evi;
      if (panel && panel.classList.contains('evi--max')) {
        eviMinimize();
        return;
      }
      if (panel && panel.classList.contains('evi--min')) {
        eviExpand();
        return;
      }
      // default: expand
      eviExpand();
    };

    const showEviTooltip = (copy: string) => {

      const eviTooltip = document.querySelector('#evi-tooltip');
      const eviTooltipCopy = document.querySelector('#evi-tooltip-copy');
      const eviTooltipMobile = document.querySelector('#evi-tooltip-mobile');
      const eviTooltipMobileCopy = document.querySelector('#evi-tooltip-mobile-copy');

      if (eviTooltipCopy) (eviTooltipCopy as HTMLElement).innerText = copy;
      if (eviTooltipMobileCopy) (eviTooltipMobileCopy as HTMLElement).innerText = copy;
      eviTooltip?.classList.add('is-active');
      eviTooltipMobile?.classList.add('is-active');

      setTimeout(() => {
        eviTooltip?.classList.remove('is-active');
        eviTooltipMobile?.classList.remove('is-active');
      }, 3000);
    };
      

    const eviThink = ({ agent = false } = {}) => {
      eviThinking?.classList.remove('d-none');
      eviTags?.classList.add('d-none');
      if (agent) return;
      eviInputWrap?.classList.add('d-none');
      eviInput?.blur();
    };

    const eviType = () => { eviTyping?.classList.remove('d-none'); scrollChatToBottom(); };

    function scrollChatToBottom() {
        const eviContent = document.querySelector('.evi__content');
        eviContent.scrollTop = eviContent.scrollHeight;
    }

    function scrollChatToLastVisibleMessage() {
        const eviContent = document.querySelector('.evi__content');
        const lastMessage = eviContent.querySelector('.evi__message:last-child');
        lastMessage.scrollIntoView({ behavior: 'smooth' });
    }


    function eviDraggable(){

        let element,
            trigger;
            

        let posX = 0, 
            posY = 0, 
            posXdiff = 0, 
            posYdiff = 0;

        let v_width,
            v_height;    

        let panel_width,
            panel_height,            
            panel_right,
            panel_btm;


        // NOTE: Evi is right-aligned in this project. Draggable calculations
        // operate only on `right` (distance from right edge) and set
        // `element.style.right` accordingly.

        const settings = {
            snapAmount: 30,
            boundary: 20
        }
        
        initDraggable();

        function initDraggable() {  

            element = evi;
            
            if(element.dataset.init) return;
            element.dataset.init = true;                

            if(element) {
                trigger = element.querySelector(".evi__header-title-icon");
            }                

            if (trigger) {            
                v_width = document.documentElement.clientWidth;
                v_height = window.innerHeight || document.documentElement.clientHeight;

                panel_width = element.offsetWidth;
                panel_height = element.offsetHeight;

                panel_right = v_width - element.getBoundingClientRect().right;
                panel_btm = v_height - element.getBoundingClientRect().bottom;    
                
                trigger.addEventListener('mousedown', dragMouseDown);
                trigger.addEventListener('touchstart', dragMouseDown);
                try { self._eviBoundListeners.push({ target: trigger, type: 'mousedown', listener: dragMouseDown }); } catch (err) { /* ignore */ }
                try { self._eviBoundListeners.push({ target: trigger, type: 'touchstart', listener: dragMouseDown }); } catch (err) { /* ignore */ }

                window.addEventListener('resize', updateAllDimensions);
                window.addEventListener('orientationchange', updateAllDimensions);
                // remember global listeners so they can be removed on destroy
                try {
                  self._eviBoundListeners.push({ target: window, type: 'resize', listener: updateAllDimensions });
                  self._eviBoundListeners.push({ target: window, type: 'orientationchange', listener: updateAllDimensions });
                } catch (err) { /* ignore */ }
                // remember global listeners so they can be removed on destroy
                try {
                  self._eviBoundListeners.push({ target: window, type: 'resize', listener: updateAllDimensions });
                  self._eviBoundListeners.push({ target: window, type: 'orientationchange', listener: updateAllDimensions });
                } catch (err) { /* ignore */ }
                
            } 
        }

        function dragMouseDown(e) {
            e = e || window.event;
            e.preventDefault();     
            
            if(element.classList.contains('evi--max')) return; 

            
            // only applicable on left click/touch
            if(e.button === 0 || typeof e.touches !== 'undefined'){

                // get the mouse cursor position at startup:              
                if (e.clientX || e.clientY) {
                    posX = e.clientX;
                    posY = e.clientY;
                } else if (typeof e.touches !== 'undefined') {
                    posX = e.touches[0].clientX;
                    posY = e.touches[0].clientY;
                }  
                

                // call a function whenever the cursor moves:
                window.addEventListener('mousemove', elementDrag);
                trigger.addEventListener('touchmove', elementDrag);
                try { self._eviBoundListeners.push({ target: window, type: 'mousemove', listener: elementDrag }); } catch (err) { /* ignore */ }
                try { self._eviBoundListeners.push({ target: trigger, type: 'touchmove', listener: elementDrag }); } catch (err) { /* ignore */ }

                // mark that a drag interaction is active (true while dragging)
                try { element.dataset.isDragging = 'true'; } catch (err) { /* ignore */ }

                // stop dragging mouseup
                window.addEventListener('mouseup', closeDragElement);
                trigger.addEventListener('touchend', closeDragElement);
                try { self._eviBoundListeners.push({ target: window, type: 'mouseup', listener: closeDragElement }); } catch (err) { /* ignore */ }
                try { self._eviBoundListeners.push({ target: trigger, type: 'touchend', listener: closeDragElement }); } catch (err) { /* ignore */ }

            }

        }

        function elementDrag(e) {            
            e = e || window.event;
            e.preventDefault();                 

            // var clientX = e.clientX || e.touches[0].clientX;
            // var clientY = e.clientY || e.touches[0].clientY;     
            if (e.clientX || e.clientY) {
                var clientX = e.clientX;
                var clientY = e.clientY;
            } else if (typeof e.touches !== 'undefined') {
                var clientX = e.touches[0].clientX;
                var clientY = e.touches[0].clientY;
            }                

            // calculate the new cursor position:
            posXdiff = posX - clientX;
            posYdiff = posY - clientY;
            posX = clientX;
            posY = clientY;            
            

            // calculate panel positioning co-ords (right-aligned)
            panel_right = v_width - element.getBoundingClientRect().right + posXdiff;
            panel_btm = v_height - element.getBoundingClientRect().bottom + posYdiff;

            
            element.dataset.isDragged = true;
        

            // set position
            elementSetPosition();

        }


        function elementSetPosition(){

            let panelTop = element.offsetTop - posYdiff;
                
            let eviBottomOffset = parseInt(getComputedStyle(element).getPropertyValue('--evi-tray-offset')) || 0;
            eviBottomOffset = eviBottomOffset + settings.boundary;
          
            // top & bottom boundaries
            if( (panel_btm <= settings.snapAmount + eviBottomOffset) && posYdiff < 0) {          
                panel_btm = eviBottomOffset;
            } else if (panel_btm < eviBottomOffset){            
                panel_btm = eviBottomOffset;
            } else if (panelTop < settings.boundary) {
                panel_btm = 0 + (v_height - panel_height) - settings.boundary;           
            } 

            // left & right boundaries (right-aligned)
            if(panel_right < settings.boundary){
              panel_right = settings.boundary;
            } else if(panel_right > v_width - panel_width - settings.boundary){
              panel_right = v_width - panel_width - settings.boundary;
            }

            element.style.left = 'auto';
            element.style.right = panel_right + (panel_width / 2) + 'px'; // offset to account for -50% translate


            // when panel_btm is at 0
            // remove bottom property to snap to default bottom position            
            if(panel_btm === eviBottomOffset){
              element.style.removeProperty('bottom');
              element.dataset.isDragged = false;
              return;
            } 

            element.style.bottom = panel_btm + 'px';                
        }


        function closeDragElement() {

            // remove listeners (correctly this time)
            window.removeEventListener('mousemove', elementDrag); 
            trigger.removeEventListener('touchmove', elementDrag);
            window.removeEventListener('mouseup', closeDragElement);
            trigger.removeEventListener('touchend', closeDragElement);                 
            // clear dragging flag
            try { delete element.dataset.isDragging; } catch (err) { /* ignore */ }
            
        }


        function updatePanelDimensionsAndConfine(){
            if (trigger) { 

                panel_width = element.offsetWidth;
                panel_height = element.offsetHeight;
            
                elementSetPosition();
            }
        }

        function updateAllDimensions(){                 
            if (trigger) { 
                v_width = document.documentElement.clientWidth;
                v_height = window.innerHeight || document.documentElement.clientHeight;

                panel_width = element.offsetWidth;
                panel_height = element.offsetHeight;
            }                
        }

      };

   

    // until the newer version of quote cover is implemented, we need to hide evi on mobile/small tablet by default
    // so if screen over 992 width, open evi
    if (window.innerWidth > 992) {
        //eviExpand();
    }
    // init dropzone uploader within evi
       let eviUploaderSelector = document.querySelector('.eviUploaderSelector') ;
      // let demoEviUploader = new Dropzone(demoEviUploaderSelector, {
      //     url: "process.php",
      //     createImageThumbnails: false,
      //     // maxFiles: 1, // to limit # files
      //     maxFilesize: 20, // in mb
      //     acceptedFiles: "application/pdf",
      //     previewTemplate: dropzonePreviewTemplate, // from common.js
      // });
    if (eviUploaderSelector && (eviUploaderSelector as any).dropzone) {
      (eviUploaderSelector as any).dropzone.destroy();
    }
     if (!this.eviSessionId){
      const date = new Date();
      this.eviSessionId = date.getTime().toString();
      this.setEviSessionCookie(this.eviSessionId);
    }
    this.dropZone = new Dropzone(eviUploaderSelector, {
      autoProcessQueue: true, // if false, call this.dropZone.processQueue()
      autoDiscover: false,
      acceptedFiles: "application/pdf",
      previewTemplate: dropzonePreviewTemplate,
      thumbnailWidth: 204,
      thumbnailHeight: 204,
      maxFilesize: 10,
      url: (_file: any) => {
        const sessionId = (this.questionFlowSessionQuery.getValue() as any)?.session_id || this.eviSessionId;
        console.log('sending file with session id:', sessionId);
        return this.baseurl + sessionId;
      },
      headers: {
        Authorization: `Bearer ${this.userStore.getValue()?.access_token}`
      }
    }).on('thumbnail', (_file: any) => {
      $(_file.previewElement).addClass('has-thumbnail');
    }).on('success', (file: any, response: any) => {

      this.pdfPasswordRequired = false;
      this.pdfPasswordInvalid = false;
      this.pdfPasswordVisible = false;
      this.pdfPassword = '';
      this.pdfPasswordAttempts = 0;
      this.pdfPasswordMessage = '';

      let jsonResponse = JSON.parse(response?.upload_response);
      this.jobId = jsonResponse?.job_id;
      this.pdfPendingFile = file;

      const immediateStatus = jsonResponse?.status;

      if (immediateStatus === 'password_required') {
        this.jobStatus = { status: 'password_required', message: '' };
        this.pdfPasswordMessage = jsonResponse?.errors?.[0]?.message || '';
        this.pdfPasswordRequired = true;
        this.pdfPasswordInvalid = false;
        $("#evi-thinking").addClass("d-none");
        $("#evi-inputwrap").removeClass("d-none");
        setTimeout(() => { scrollToItem('dz-complete', true); }, 1000);
        return;
      }

      this.uploadInProgress = true;
      this.startPollingStatus();
      this.jobStatus = {status: 'uploading', message: "Your policy schedule was uploaded successfully."};
      $("#evi-thinking").removeClass("d-none");
      $("#evi-inputwrap").addClass("d-none");
      setTimeout(() => { scrollToItem('dz-complete', true); }, 1000);
    }).on('removedfile', (file: any) => {
      const deletedFile = this.savedResources.find((item: any) => item.file === file?.upload?.uuid);
      if (deletedFile) {
        this.savedResources = this.savedResources.filter((item: any) => item.file !== file?.upload?.uuid);
        this.removeFile(deletedFile.resource_id);
        if (!this.savedResources || this.savedResources?.length) {
          //this.question.answer = '';
          //this.questionAnswer.emit(this.question);
        }
      }
    }).on('error', (_file: any, response: any) => {
      // Client-side Dropzone errors (e.g. file too large) are plain strings — skip further logic
      if (typeof response === 'string') return;

      this.jobStatus = {status: "ready"};

      if (response?.indexOf('401') !== -1) {
        //this.router.navigate([RouterLinks.Login], { queryParams: { returnUrl: this.router.routerState.snapshot.url } });
      }
    });
    this._eviApi = { eviClose, eviExpand, eviMinimize, eviDisable, eviMinMaxToggle, eviThink, eviType, eviDraggable, showEviTooltip, scrollChatToBottom, scrollChatToLastVisibleMessage };
    return this._eviApi;
  }
  sendJsonRequest(file: any, jsonBody: any) {
    const API_ENDPOINT = environment.eviAutofillEndpoint;
    const API_KEY = environment.eviAutofillKey;

    // This updates Dropzone's status bar to show progress
    const total = file.upload.total;
    let sent = 0;
    const interval = setInterval(() => {
      sent += 1000;
      this.dropZone.emit('uploadprogress', file, (sent / total) * 100);
      if (sent >= total) {
        clearInterval(interval);
      }
    }, 10);

    fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'x-api-key': API_KEY,
        'Content-Type': 'application/json', // CRITICAL: Content-Type is set here
      },
      body: JSON.stringify(jsonBody), // CRITICAL: JSON payload is sent here
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Upload failed with status: ' + response.status);
        }
        return response.json();
      })
      .then(responseJson => {
        // 4. Tell Dropzone the file upload was a success
        this.dropZone.emit('success', file, responseJson);
        this.dropZone.emit('complete', file);

        // You can now proceed with your existing success logic:
        // this.uploadInProgress = true;
        // this.jobId = '...';
        // this.startPollingStatus();
        // this.sendRequest(responseJson);
      })
      .catch(error => {
        // 5. Tell Dropzone the file upload failed
        this.dropZone.emit('error', file, error.message);
        this.dropZone.emit('complete', file);
      });
  }
  removeFile(_resource_id: string): void {
    //this.questionService.removeFile(resource_id).subscribe();
  }  

  sendRequest(file_path: string = ''): void {
   this.person = this.userStore.getValue();
    if (!this.eviSessionId){
      const date = new Date();
      this.eviSessionId = date.getTime().toString();
      this.setEviSessionCookie(this.eviSessionId);
    }
    
     $("#evi-inputwrap").addClass("d-none");
     let user = 'anonymous';
     if (this.person?.person_id) user = this.person.first_name;
    let prompt = $('#evi-input').val();
    if (!prompt || prompt.toString().trim() === '') prompt = 'Here is a document for you to review.';
    this.chats.push({
      chat_id: 0,
      chat_index: this.index,
      session_id: this.eviSessionId,
      chat_type: "request",
      chat_text: prompt,
      avatar: "",
      file_path: file_path,
      chat_user: user
    })
    setTimeout(() => {
      $("#evi-thinking").removeClass("d-none");
      scrollToItem('evi__message-request-'+this.index.toString());
    }, 500);
    let person_id = 0;
    let policy_id = '';
    
    if (this.person?.person_id) person_id = this.person.person_id;
    
    if (this.policy?.policy_id) policy_id = this.policy.policy_id;
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.eviSessionId);
    parameters.set('index', this.index.toString());
    parameters.set('person_id', person_id.toString());
    parameters.set('policy_id', policy_id);
    parameters.set('prompt', prompt);
    parameters.set('user', user);
    parameters.set('file_path', file_path);
    parameters.set('avatar', '');
    this.questionService.runCommandNew(`[api].[sendAIRequest]`, parameters).subscribe((response) => {
      if (response.length > 0 && response[0].response) {
        this.chats.push({
          chat_id: response[0].chat_id,
          chat_index: this.index,
          session_id: this.eviSessionId,
          chat_type: "response",
          chat_text: response[0].response.replace(/\n/g, "<br>"),
          avatar: "",
          chat_user: "Evi"
        })
      }
      else {
        this.chats.push({
          chat_id: 0,
          chat_index: this.index,
          session_id: this.eviSessionId,
          chat_type: "response",
          chat_text: "Oops! Something went wrong. Please try again later.",
          avatar: "",
          file_path: file_path,
          chat_user: "Evi"
        })
      }
      const audio = new Audio('assets/sounds/bell.mp3');
      audio.play().catch((error) => {
        //console.error('Error playing sound:', error);
      });
      $("#evi-thinking").addClass("d-none");
      $("#evi-inputwrap").removeClass("d-none");
      setTimeout(() => {
        scrollToItem('evi__message-response-'+this.index.toString());
        this.index++;
      }, 500);
      $('#evi-input').val("");
      $('#evi-input').focus();
      
    }, () => {
      this.chats.push({
        chat_id: 0,
        chat_index: this.index,
        session_id: this.eviSessionId,
        chat_type: "response",
        chat_text: "Oops! Something went wrong. Please try again later.",
        avatar: "",
        file_path: file_path,
        chat_user: "Evi"
      })
      
      $("#evi-thinking").addClass("d-none");
      $("#evi-inputwrap").removeClass("d-none");
      setTimeout(() => {
        scrollToItem('evi__message-response'+this.index.toString());
        this.index++;
      }, 500);
    });
  }
  checkEnter(e: any): void {
    if (e.keyCode === 13 && !e.shiftKey) {
      e.preventDefault();
      if ($('#evi-input').val().trim() === '') return;
      this.sendRequest();
    }
  }
  checkEviState(ev: any): void {
   
      try{

        const urlParams = new URLSearchParams(ev?.url.split('?')[1]);
        if (urlParams.get('eviState')) {
          localStorage.setItem('eviState', urlParams.get('eviState'));
          this.showUploadSection = true;
          this.uploadDisclaimerAccepted = false;
          this.acceptTerms("Hi, I’m Evi. I’m here to help you find the perfect insurance for your needs. If you have a current policy schedule, or multiple, you can upload them here for me to review and help streamline your quote process.");
        }
       
        let eviState = localStorage.getItem('eviState');

        if(eviState == 'expanded'){    
          this.initEvi().eviExpand();
        }
        else if (eviState == 'minimized'){ 
          this.initEvi().eviMinimize(); 
        }
        else if (eviState == 'closed' || eviState == 'disabled'){   
          this.initEvi().eviClose();
        } 
        else if (eviState == 'quote'){
          //alert('quick quote')

        }        
        if (!eviState) {
          this.initEvi().eviMinimize();
        }
      }
      catch (e){ /* ignore */ }
      //console.log(ev)
        if ( 
          ev?.url?.includes(RouterLinks.QuestionFlow) 
          || ev?.url?.includes(RouterLinks.QuoteUWPage)
          ){
          this.class = 'evi--tray-offset';
        }
        else{
          this.class = '';
        }
        scrollToItem('evi__message-request-'+(this.index-1).toString());
          
  
    
    
  }
  acceptTerms(text: string = ''): void {
    this.termsAccepted = true;
    if (!this.eviSessionId){
      const date = new Date();
      this.eviSessionId = date.getTime().toString();
      this.setEviSessionCookie(this.eviSessionId);
    }
    this.index++;
    if (text === '') text = 'How can I help you today?';
    this.chats.push({
      chat_id: 0,
      chat_index: this.index,
      session_id: this.eviSessionId,
      chat_type: "response",
      chat_text: text,
      avatar: "",
      file_path: '',
      chat_user: "Evi"
    })
    //const eviInput = document.querySelector<HTMLInputElement>('#evi-input');
    setTimeout(() => {
      $('#evi-input').focus();
    }, 1000);

  }

  setReaction(chat: any, reaction: number): void {

    chat.reaction = reaction;
    const parameters = new Map<string, string>();
    parameters.set('chat_id', chat.chat_id.toString());
    parameters.set('reaction', reaction.toString());
    this.questionService.runCommandNew(`[api].[setChatReaction]`, parameters).subscribe((response) => {
      // if (response.length > 0) {
      //   chat.reaction = reaction;
      // }
    })
  }
  initAIModal(event: any, modal: any): any {
   //this.eviSessionId = '1775821532075'; //test
    const param = new Map<string, string>();
    param.set('session_id',  this.eviSessionId);
    param.set('category_id', '0');
    param.set('product_group_id', '0');
    param.set('page', 'evi-quote-landing');
    param.set('referer_id', '1');
    param.set('broker_user_id', this.person?.person_id.toString());
    param.set('broker_id', this.person?.broker_id.toString());

     this.questionService.runCommandNew('getPageInfo', param)
      .subscribe(info => {
        this.pageInfo = info;
      });

     this.loadQuestions();
       
  }
  loadQuestions(): void {
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.eviSessionId);
    parameters.set('evi', '1');
    parameters.set('person_id', this.person?.person_id.toString());
    this.questionService.runCommandNew(`getQuestions`, parameters).subscribe(questions => {

      questions.forEach((q: Question) => {
        // Only store if an answer actually exists
        if (q.answer !== undefined && q.answer !== null) {
          this.originalAnswers.set(q.cent_aq_question_id, q.answer);
        }
      });
      this.classes = Object.values(questions.reduce((acc, item) => {
        // 1. Check for uniqueness first. If class_id is already in the accumulator, skip it.
       if (!acc.hasOwnProperty(item.class_id)) {

          // 2. Handle the special case: class_id 0 OR (class_id > 0 AND product_class is NOT null)
          if (item.class_id === 0) {
            acc[item.class_id] = {
              class_id: 0,
              product_class: "Policy details" // Set the specified value
            };
          } else if (item.product_class !== null) {
            // Handle all standard, non-null product classes
            acc[item.class_id] = {
              class_id: item.class_id,
              product_class: item.product_class
            };
          }
        }
        return acc;
      }, {} as {  class_id: number, product_class: string  }));
      
      this.activeDependentQuestionId = -1;
      this.dependentFlowActive = false;
      this.dependentFlowDone = false;
      this.dependentQuestions = [];
      this.answeredQuestions = [];
      this.currentQuestion = null;

      this.questions = questions.reduce((acc, currentItem) => {
        // Parse extraction_details JSON if it's a string
        if (typeof currentItem.extraction_details === 'string') {
          try {
            currentItem.extraction_details = JSON.parse(currentItem.extraction_details);
          } catch (error) {
            currentItem.extraction_details = null;
          }
        }
        if (!currentItem.extraction_details) {
          return acc; // Skip this item and return the accumulator as is
        }
        // Convert the numeric status to a string to use as a dynamic object key
        const statusKey = String(currentItem.extraction_status);

        // Initialize the array for this status if it doesn't exist
        if (!acc[statusKey]) {
          acc[statusKey] = [];
        }
        // Push the current item into the correct status array
        acc[statusKey].push(currentItem);

        return acc;
      }, {} as Record<string, typeof questions>);
      
      //console.log(this.questions[Status.Conflict], this.questions[Status.Missing], this.questions[Status.Review]);
      if (this.questions[Status.Conflict]) {
        this.currentStatus = Status.Conflict;
        this.step = 1;

      } else if (this.questions[Status.Missing]) {
        this.currentStatus = Status.Missing;
        this.step = 2;
        this.conflicting = false;
        this.missing = true;
      } else {
        this.currentStatus = Status.Review;
        this.step = 3;
        this.conflicting = false;
        this.missing = false;
      }
      this.questionService.spinner(false);
      setTimeout(() => {
         this.initModalListeners();
      }, 500);
     
    }, () => {
      $('#error-modal').modal('show');
      this.questionService.spinner(false);
    });
    console.log(this.questions)
  }
  initModalListeners(): any {
    // Prefer typed, safe element lookups and guard early if required elements are missing.
    // In a full Angular refactor you would replace these with @ViewChild / Renderer2 bindings;
    // here we keep runtime lookups but make them safer and typed.

    const getBySel = (sel: string) => document.querySelector<HTMLElement>(sel) ?? null;
    const getById = (id: string) => document.getElementById(id) as HTMLElement | null;

    const AIModal = getBySel(".ai-modal");
    if (!AIModal) {
      return;
    }

    this.AIModalContent = AIModal.querySelector<HTMLElement>(".ai-modal__content") ?? null;
    this.AIModalBackdrop = AIModal.querySelector<HTMLElement>(".ai-modal__backdrop") ?? null;

   this.demoAIModalNav = getById("demo-ai-modal-nav");
    this.demoAIContentQuestions = getById("demo-ai-content-questions");
   this.demoAIContentEdit = getById("demo-ai-content-edit");
    this.demoConflictingInfoBtn = getById("demo-conflicting-info-btn");
    this.demoReviewInfoBtn = getById("demo-review-btn");
    this.demoSidebarInfoNav = getById("demo-ai-modal-infonav");
    this.demoSidebarReviewNav = getById("demo-ai-modal-reviewnav");

    this.demoConflictingItemsNav = getById("demo-conflicting-items-nav");
    this.demoMissingItemsNav = getById("demo-missing-items-nav");
    this.reviewDetailsNav = getById("review-details-nav");
    this.reviewInsuredItemsNav = getById("review-insured-items-nav");

    this.demoAIBackBtn = getById("demo-ai-modal-back-btn");
    this.demoAITrayBtn = getById("demo-ai-tray-btn");

    // // Basic validation logging for missing (but non-critical) nodes
    // const optionalNodes = [
    //   { name: 'AIModalContent', node: AIModalContent },
    //   { name: 'AIModalBackdrop', node: AIModalBackdrop },
    //   { name: 'demoAIModalNav', node: demoAIModalNav },
    //   { name: 'demoAIContentQuestions', node: demoAIContentQuestions },
    //   { name: 'demoAIContentEdit', node: demoAIContentEdit },
    //   { name: 'demoConflictingInfoBtn', node: demoConflictingInfoBtn },
    //   { name: 'demoReviewInfoBtn', node: demoReviewInfoBtn },
    //   { name: 'demoSidebarInfoNav', node: demoSidebarInfoNav },
    //   { name: 'demoSidebarReviewNav', node: demoSidebarReviewNav },
    //   { name: 'demoConflictingItemsNav', node: demoConflictingItemsNav },
    //   { name: 'demoMissingItemsNav', node: demoMissingItemsNav },
    //   { name: 'reviewDetailsNav', node: reviewDetailsNav },
    //   { name: 'reviewInsuredItemsNav', node: reviewInsuredItemsNav },
    //   { name: 'demoAIBackBtn', node: demoAIBackBtn },
    //   { name: 'demoAITrayBtn', node: demoAITrayBtn }
    // ];

    // optionalNodes.forEach(n => {
    //   if (!n.node) {
    //     console.warn(`${n.name} not found in DOM`);
    //   }
    // });

        let exitAlert = false // can exit ai modal without warning modal
        const self = this;

        function openAIModal() {
          AIModal.classList.add("is-active")
          document.querySelector("body").classList.add("ai-modal-open");
          $('.evi').removeClass('evi--max');
         
           $('.evi-backdrop').removeClass('is-active');
        }
        

        function closeAIModal() {
          if(exitAlert) {
            $("#exit-modal").modal("show");
            return; 
          }

          AIModal.classList.remove("is-active")
          document.querySelector("body").classList.remove("ai-modal-open")
        }
        
        //event.preventDefault();

          openAIModal();

          // on backdrop click listener
          self.AIModalBackdrop?.addEventListener("click", closeAIModal)


          self.demoAIBackBtn?.addEventListener("click", function(e) {
            e.preventDefault();
            openGetStartedDemo(1);

            // reset sidebar nav
            self.demoSidebarInfoNav?.classList.remove("d-none");
            self.demoSidebarReviewNav?.classList.add("d-none");
          })


          document.getElementById("discard-changes-demo-btn")?.addEventListener("click", function (e) {        
            e.preventDefault()
            exitAlert = false
            closeAIModal()
          })



          demoSearchToggle()

          demoSortToggle()

          demoSelectDrop()

          //
          // setup listeners for the various demo journeys
          //

          // conflicting info button
          
          self.demoConflictingInfoBtn?.addEventListener("click", function(e) {
            e.preventDefault();
            self.demoAIContentQuestions?.classList.add("d-none")
            self.demoAIModalNav?.classList.remove("d-none")            
            self.demoAIContentEdit?.classList.remove("d-none")            

            initConflictingDemo();
          })


          // missing info button
          document.getElementById("demo-missing-info-btn")?.addEventListener("click", function(e) {
            e.preventDefault();
            self.demoAIContentQuestions?.classList.add("d-none")

            self.demoAIModalNav?.classList.remove("d-none")
            self.demoAIContentEdit?.classList.remove("d-none")

            //initMissingDemo();
          })


          // review button
          self.demoReviewInfoBtn?.addEventListener("click", function(e) {
            e.preventDefault();
            self.demoAIContentQuestions?.classList.add("d-none")

            self.demoAIModalNav?.classList.remove("d-none")
            self.demoAIContentEdit?.classList.remove("d-none")
            //initReviewDemo();
          })
          
        function openGetStartedDemo(step){
          self.demoAIContentQuestions?.classList.remove("d-none")

          self.demoAIModalNav?.classList.add("d-none")          
          self.demoAIContentEdit?.classList.add("d-none")


          if(step && step === 2){
            // show heading 2
            document.getElementById("demo-ai-content-heading-1")?.classList.add("d-none");
            document.getElementById("demo-ai-content-heading-2")?.classList.remove("d-none");
            document.getElementById("demo-ai-content-heading-3")?.classList.add("d-none");
          } else if(step && step === 3){
            // show heading 3
            document.getElementById("demo-ai-content-heading-1")?.classList.add("d-none");
            document.getElementById("demo-ai-content-heading-2")?.classList.add("d-none");
            document.getElementById("demo-ai-content-heading-3")?.classList.remove("d-none");
          }

        }

        function openAIModalItems(event, itemId) {
          event.preventDefault();
          
          // open item
          const targetItem = document.getElementById(itemId)
          targetItem.classList.remove("d-none")

          // hide sibling items
          const siblings = Array.from(targetItem.parentElement.children).filter(function (el) {
            return el !== targetItem
          })
          siblings.forEach(function (el) {
            el.classList.add("d-none")
          })


          // open first item in resultant edit-nav by default
          targetItem.querySelectorAll('.edit-nav li')[0]?.querySelector('a').click();


          // set active list item state
          const targetListItem = event.target.closest("li")
          targetListItem.classList.add("is-active")

          // find all siblings within closest ul
          const editNav = targetListItem.closest("ul")
          const siblingsList = Array.from(editNav.querySelectorAll("li")).filter(function (el) {
            return el !== targetListItem
          })
          // and remove active state from siblings
          siblingsList.forEach(function (el) {
            (el as Element).classList.remove("is-active")
          })

          


        }

        function openAIModalItem(event, itemId) {
          event.preventDefault();
          // show item
          const allItems = document.querySelectorAll("#edit-item-col .edit-modal__content-wrap")
          allItems.forEach(item => {
            item.classList.add("d-none")
          })
          const activeItem = document.getElementById(itemId)
          if (activeItem) {
            activeItem.classList.remove("d-none")

            // demo scroll to top of item content
            //activeItem.querySelector('.edit-modal__content-body').scrollTo({ top: 0, behavior: 'instant' });
          }


          // set active list item state
          if (event !== null) {
            const targetListItem = event.target.closest("li")
            targetListItem.classList.add("is-active")

            // find all siblings within closest .edit-nav            
            const editNav = targetListItem.closest(".edit-nav")
            const siblingsList = Array.from(editNav.querySelectorAll("li")).filter(function (el) {
              return el !== targetListItem
            })
            
            // and remove active state from siblings
            siblingsList.forEach(function (el) {
              (el as Element).classList.remove("is-active")
            })
          }

        }

         function initReviewDemo(){
          self.demoAITrayBtn!.textContent = "Continue";
          self.demoAITrayBtn?.removeAttribute("disabled");

          self.demoConflictingItemsNav?.classList.add("d-none")
          self.demoMissingItemsNav?.classList.add("d-none")

          self.demoSidebarInfoNav?.classList.add("d-none")
          self.demoSidebarReviewNav?.classList.remove("d-none")
          
          // by default, open the 'items' items nav
          document.getElementById("demo-ai-modal-reviewnav-items")?.click();

          // demo remove all the evi notices
          document.querySelectorAll("#edit-item-col .notice.notice--lg.notice--evi")?.forEach(function (el) {
            el.remove();
          });


          // on next click, continue to 
          self.demoAITrayBtn?.addEventListener("click", function(e) {
            e.preventDefault();

            // show complete version of button in 'get started' nav
            document.getElementById("demo-review-btn")?.classList.add("d-none");
            document.getElementById("demo-review-btn-complete")?.classList.remove("d-none");

            // enable next item in 'get started' nav
            // document.getElementById("demo-add-btn").classList.remove("is-inactive")

            // reset sidebar nav
            self.demoSidebarInfoNav?.classList.remove("d-none");
            self.demoSidebarReviewNav?.classList.add("d-none");

            self.demoAITrayBtn!.textContent = "Continue to quotes";
            self.demoAITrayBtn?.removeAttribute("disabled");
            
            // button click listener to take to quote loading page
            self.demoAITrayBtn?.addEventListener("click", function(e) {
              e.preventDefault();
              window.location.href = "/pages/questionnaire-choose-loading.html?state=no-progress";
            })

            // open get started section             
            openGetStartedDemo(4);          

          });

        }

        function initMissingDemo(){

          self.demoAITrayBtn!.textContent = "Next";
          self.demoAITrayBtn?.setAttribute("disabled", "true");

          self.demoConflictingItemsNav?.classList.add("d-none")
          self.demoMissingItemsNav?.classList.remove("d-none")

          const missingTrigger1 = document.getElementById("missing-trigger-1");

          // insert a delay to give the user time to see the journey
          setTimeout(() => {
            missingTrigger1.click();

            setTimeout(() => {               
              // scroll to the 1st conflicting item
              const missingItem = document.getElementById("demo-missing-item-1");
              missingItem.scrollIntoView({ behavior: "smooth", block: "start" });                  
            }, 500);
          });


          // listen for when changes are made to required field ...assume valid change
          document.getElementById('demo-missing-item-input-1')?.addEventListener("change", function (e) {
           

            // remove conflicting class and note
            document.getElementById("demo-missing-item-1")?.classList.remove('card--edit-modal--outstanding')
            document.getElementById("demo-missing-item-1")?.querySelector('.card__tray')?.classList.add('d-none');   
          
            self.demoAITrayBtn?.removeAttribute("disabled");
            self.demoAITrayBtn!.textContent = "Continue";

            missingTrigger1.querySelector('.tag-pill')?.classList.add('d-none');

          });


          // on next click
          self.demoAITrayBtn?.addEventListener("click", function(e) {
            e.preventDefault();

            // show complete version of button in 'get started' nav
            document.getElementById("demo-missing-info-btn")?.classList.add("d-none");
            document.getElementById("demo-missing-info-btn-complete")?.classList.remove("d-none");

            // enable next item in 'get started' nav
            document.getElementById("demo-review-btn")?.classList.remove("is-inactive")

            self.demoAITrayBtn!.textContent = "Continue to quotes";
            self.demoAITrayBtn?.setAttribute("disabled", "true");

            // open get started section             
            openGetStartedDemo(3);

          });



        }

        function initConflictingDemo(){

          // demoAITrayBtn.textContent = "Next";
          // demoAITrayBtn.setAttribute("disabled", "true");

          self.demoConflictingItemsNav?.classList.remove("d-none")
          self.demoMissingItemsNav?.classList.add("d-none")

           const conflictingTrigger1 = document.getElementById("conflicting-trigger-1");
          const conflictingTrigger3 = document.getElementById("conflicting-trigger-3");
          const conflictingTrigger4 = document.getElementById("conflicting-trigger-4");

          // insert a delay to give the user time to see the journey
          setTimeout(() => {
           // conflictingTrigger1.click();

            setTimeout(() => {                 
              // scroll to the 1st conflicting item
              const conflictingItem = document.getElementById("demo-conflicting-item-1");
              conflictingItem.scrollIntoView({ behavior: "smooth", block: "start" });                  
            }, 500);


          }, 500); 

          //return;
          // set inactive states for conflicting items    
          // conflictingTrigger1.closest('.edit-nav__group')?.classList.remove('is-inactive');      
          // conflictingTrigger1.parentElement?.classList.remove('is-inactive');

          // conflictingTrigger3.closest('.edit-nav__group')?.classList.add('is-inactive');
          // conflictingTrigger3.parentElement?.classList.add('is-inactive');
          // conflictingTrigger4.parentElement?.classList.add('is-inactive');

          // let conflictingItemsChanged = 0;

          // // listen for when changes are made to required field ...assume valid change
          // document.getElementById('demo-conflicting-item-input-1')?.addEventListener("change", function (e) {
          //   conflictingItemsChanged++;

          //   // allow exit without warning
          //   exitAlert = true; 

          //   // remove conflicting class and note
          //   document.getElementById("demo-conflicting-item-1")?.classList.remove('card--edit-modal--outstanding')
          //   document.getElementById("demo-conflicting-item-1")?.querySelector('.card__tray')?.classList.add('d-none');     
            
          //   // update 'Conflicting' text in nav item
          //   conflictingTrigger1.querySelector('.tag-pill').textContent = "Conflicting (1)";

          // });


          // // listen for when changes are made to required field ...assume valid change
          // document.getElementById('demo-conflicting-item-input-2')?.addEventListener("change", function (e) {
          //   conflictingItemsChanged++;

          //   // remove conflicting class and note
          //   document.getElementById("demo-conflicting-item-2")?.classList.remove('card--edit-modal--outstanding')
          //   document.getElementById("demo-conflicting-item-2")?.querySelector('.card__tray')?.classList.add('d-none');

          //   self.demoAITrayBtn?.removeAttribute("disabled");
          //   self.demoAITrayBtn!.textContent = "Next";

          //   conflictingTrigger1.querySelector('.tag-pill').classList.add('d-none');
            

          // });

          // // listen for when changes are made to required field ...assume valid change
          // document.getElementById('demo-conflicting-item-input-3')?.addEventListener("change", function (e) {
          //   conflictingItemsChanged++;

          //   // remove conflicting class and note
          //   document.getElementById("demo-conflicting-item-3")?.classList.remove('card--edit-modal--outstanding')
          //   document.getElementById("demo-conflicting-item-3")?.querySelector('.card__tray')?.classList.add('d-none');

          //   self.demoAITrayBtn?.removeAttribute("disabled");
          //   self.demoAITrayBtn!.textContent = "Next";

          //   conflictingTrigger3.querySelector('.tag-pill').classList.add('d-none');

          // });

          // // listen for when changes are made to required field ...assume valid change
          // document.getElementById('demo-conflicting-item-input-4')?.addEventListener("change", function (e) {
          //   conflictingItemsChanged++;

          //   // remove conflicting class and note
          //   document.getElementById("demo-conflicting-item-4")?.classList.remove('card--edit-modal--outstanding')
          //   document.getElementById("demo-conflicting-item-4")?.querySelector('.card__tray')?.classList.add('d-none');

          //   self.demoAITrayBtn?.removeAttribute("disabled");
          //   self.demoAITrayBtn!.textContent = "Continue";

          //   conflictingTrigger4.querySelector('.tag-pill').classList.add('d-none');

          // });

          // // on next click, we need to trigger the next conflicting item menu item
          // self.demoAITrayBtn?.addEventListener("click", function(e) {
          //   e.preventDefault();
            

          //   if (conflictingItemsChanged === 2) {

          //     self.demoAITrayBtn?.setAttribute("disabled", "true");
          //     const conflictingTrigger = document.getElementById("conflicting-trigger-3");
          //     conflictingTrigger.click();

          //     setTimeout(() => {
          //       const conflictingItem = document.getElementById("demo-conflicting-item-3");
          //       conflictingItem.scrollIntoView({ behavior: "smooth", block: "start" }); 
          //     }, 500);


          //     // set inactive states for conflicting items
          //     conflictingTrigger1.closest('.edit-nav__group')?.classList.add('is-inactive');
          //     conflictingTrigger1.parentElement?.classList.add('is-inactive');

          //     conflictingTrigger3.closest('.edit-nav__group')?.classList.remove('is-inactive');
          //     conflictingTrigger3.parentElement?.classList.remove('is-inactive');
          //     conflictingTrigger4.parentElement?.classList.add('is-inactive');
              
          //   }

          //   if (conflictingItemsChanged === 3) {

          //     self.demoAITrayBtn?.setAttribute("disabled", "true");
          //     const conflictingTrigger = document.getElementById("conflicting-trigger-4");
          //     conflictingTrigger.click();

          //     setTimeout(() => {
          //       const conflictingItem = document.getElementById("demo-conflicting-item-4");
          //       conflictingItem.scrollIntoView({ behavior: "smooth", block: "start" }); 
          //     }, 500);   
              
              
          //     // set inactive states for conflicting items
          //     conflictingTrigger1.closest('.edit-nav__group')?.classList.add('is-inactive');
          //     conflictingTrigger1.parentElement?.classList.add('is-inactive');

          //     conflictingTrigger3.closest('.edit-nav__group')?.classList.remove('is-inactive');
          //     conflictingTrigger3.parentElement?.classList.add('is-inactive');
          //     conflictingTrigger4.parentElement?.classList.remove('is-inactive');

          //   }

          //   // all conflicting steps done
          //   if (conflictingItemsChanged === 4) {

          //     // show complete version of button in 'get started' nav
          //     document.getElementById("demo-conflicting-info-btn")?.classList.add("d-none");
          //     document.getElementById("demo-conflicting-info-btn-complete")?.classList.remove("d-none");

          //     // enable next item in 'get started' nav
          //     document.getElementById("demo-missing-info-btn")?.classList.remove("is-inactive")

          //     self.demoAITrayBtn!.textContent = "Continue to quotes";
          //     self.demoAITrayBtn?.setAttribute("disabled", "true");

          //     // open get started section             
          //     openGetStartedDemo(2);
          //   }


          // })  

        }

        function demoSearchToggle() {
          const searchBtns = document.querySelectorAll(".edit-modal__filters-search")

          // listen for search open
          searchBtns.forEach(function (el) {
            el.addEventListener("click", function (e) {
              e.preventDefault()

              const target = document.getElementById(el.getAttribute("data-target"))
              target.classList.add("is-active")

              // focus input
              target.querySelector("input").focus()

              let navItems = el.closest(".edit-modal__content-wrap").querySelector(".edit-modal__content-body .edit-nav--items")

              demoSearchNavItems(navItems, target.querySelector("input"))
            })
          })

          // listen for search close
          const searchCloseBtns = document.querySelectorAll(".edit-modal__search-close")
          searchCloseBtns.forEach(function (el) {
            el.addEventListener("click", function (e) {
              e.preventDefault()

              const target = el.closest(".edit-modal__search")
              target.classList.remove("is-active")

              let navItems = el.closest(".edit-modal__content-wrap").querySelector(".edit-modal__content-body .edit-nav--items")

              resetSearchNavItems(navItems, target.querySelector("input"))
            })
          })
        }

        function demoSearchNavItems(navItems, input) {
          // on input change, search each list item for a match and hide the rest
          input.addEventListener("input", function (e) {
            let search = e.target.value.toLowerCase()
            let items = navItems.querySelectorAll("li")

            if (search.length < 1 && search !== "") return

            // hide all parent groups on valid input
            navItems.querySelectorAll(".edit-nav__group").forEach(function (group) {
              group.classList.add("d-none")
            })

            items.forEach(function (item) {
              let text = item.textContent.toLowerCase()
              let match = text.includes(search)

              if (match) {
                // unhide parent group if match
                item.closest(".edit-nav__group").classList.remove("d-none")
                item.classList.remove("d-none")
              } else {
                item.classList.add("d-none")
              }
            })
          })
        }

        function resetSearchNavItems(navItems, input) {
          // clear input
          input.value = ""

          // reset all nav items to visible
          navItems.querySelectorAll("li").forEach(function (item) {
            item.classList.remove("d-none")
          })

          // reset all parent groups to visible
          navItems.querySelectorAll(".edit-nav__group").forEach(function (group) {
            group.classList.remove("d-none")
          })
        }

        function demoSortToggle() {
          const sortBtns = document.querySelectorAll(".edit-modal__filters-sort")

          // listen for sort toggle
          sortBtns.forEach(function (el) {
            el.addEventListener("click", function (e) {
              e.preventDefault()

              let navItems = el.closest(".edit-modal__content-wrap").querySelector(".edit-modal__content-body .edit-nav--items")

              // toggle between is-desc and is-asc
              if (el.classList.contains("is-desc")) {
                el.classList.remove("is-desc")
                el.classList.add("is-asc")
                demoSortNavItems(navItems, "asc")
              } else {
                el.classList.remove("is-asc")
                el.classList.add("is-desc")
                demoSortNavItems(navItems, "dsc")
              }
            })
          })
        }

        function demoSortNavItems(navItems, sortDirection) {
          // sort nav item groups by sort direction
          let groups = navItems.querySelectorAll(".edit-nav__group")

          // sort groups by title within .edit-nav__title
          let sortedGroups = Array.from(groups).sort(function (a, b) {
            let aTitle = (a as Element).querySelector(".edit-nav__title").textContent
            let bTitle = (b as Element).querySelector(".edit-nav__title").textContent

            if (sortDirection === "asc") {
              return bTitle.localeCompare(aTitle)
            } else if (sortDirection === "dsc") {
              return aTitle.localeCompare(bTitle)
            } else {
              return 0;
            }
          })

          // append sorted groups back to navItems
          sortedGroups.forEach(function (group) {
            navItems.appendChild(group)
          })
        }

        function demoSelectDrop() {
          const selectDrops = document.querySelectorAll(".edit-modal__back-title .dropdown-menu .dropdown-item")

          selectDrops.forEach(function (el) {
            el.addEventListener("click", function (e) {
              e.preventDefault()

              // remove is-active from all dropdown items
              el.closest(".dropdown-menu")
                .querySelectorAll(".dropdown-item")
                .forEach(function (el) {
                  el.classList.remove("is-active")
                })

              // mark is-active
              el.classList.add("is-active")

              let target = el.closest(".edit-modal__back-title").querySelector('a[data-toggle="dropdown"] strong')
              target.textContent = el.textContent

              let navItems = el.closest(".edit-modal__content-wrap").querySelector(".edit-modal__content-body .edit-nav--items")

              demoShowSelectedGroups(navItems, el.textContent)
            })
          })
        }

        function demoShowSelectedGroups(navItems, group) {
          // if group contains 'all' show all groups
          if (group.toLowerCase().includes("all")) {
            navItems.querySelectorAll(".edit-nav__group").forEach(function (groupEl) {
              groupEl.classList.remove("d-none")

              // show any hidden titles
              groupEl.querySelector(".edit-nav__title").classList.remove("d-none")
            })
            return
          }

          // hide all parent groups on valid input
          navItems.querySelectorAll(".edit-nav__group").forEach(function (groupEl) {
            groupEl.classList.add("d-none")
          })

          // show selected group based on edit-nav__title
          navItems.querySelectorAll(".edit-nav__group").forEach(function (groupEl) {
            if (groupEl.querySelector(".edit-nav__title").textContent === group) {
              groupEl.classList.remove("d-none")

              // and hide title
              groupEl.querySelector(".edit-nav__title").classList.add("d-none")
            }
          })
        }

     return { openAIModal, closeAIModal, initMissingDemo, initConflictingDemo, demoSearchToggle, demoSortToggle, demoSelectDrop, openAIModalItem , openGetStartedDemo};   

  }
  getJobStatus(jobId: string): Observable<any> {
    const body = { job_id: jobId };
    return this.http.post<any>(API_PATH.EVI_UPLOAD_STATUS + `/${this.jobId}`, body);
  }
  submitPdfPassword(): void {
    if (!this.pdfPassword?.trim()) return;
    if (this.PDF_PASSWORD_MAX_ATTEMPTS > 0 && this.pdfPasswordAttempts >= this.PDF_PASSWORD_MAX_ATTEMPTS) return;
    this.pdfPasswordRequired = false;
    this.pdfPasswordInvalid = false;
    this.pdfPasswordVisible = false;
    $("#evi-thinking").removeClass("d-none");
    $("#evi-inputwrap").addClass("d-none");
    this.reUploadWithPassword();
  }

  reUploadWithPassword(): void {
    const sessionId = (this.questionFlowSessionQuery.getValue() as any)?.session_id || this.eviSessionId;
    const formData = new FormData();
    formData.append('file', this.pdfPendingFile);
    formData.append('pdf_password', this.pdfPassword);
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.userStore.getValue()?.access_token}`
    });

    this.http.post<any>(this.baseurl + sessionId, formData, { headers }).subscribe(
      (response: any) => {
        const jsonResponse = JSON.parse(response?.upload_response);
        this.jobId = jsonResponse?.job_id;
        const status = jsonResponse?.status;

        if (status === 'password_required' || status === 'invalid_password') {
          this.pdfPasswordAttempts++;
          this.pdfPasswordMessage = jsonResponse?.errors?.[0]?.message || this.pdfPasswordMessage;
          this.pdfPasswordRequired = true;
          this.pdfPasswordInvalid = true;
          this.jobStatus = { status, message: '' };
          $("#evi-thinking").addClass("d-none");
          $("#evi-inputwrap").removeClass("d-none");
          return;
        }

        this.uploadInProgress = true;
        this.startPollingStatus();
        this.jobStatus = { status: 'uploading', message: 'Your policy schedule was uploaded successfully.' };
      },
      () => {
        this.jobStatus = { status: 'error', message: 'Oh no! something went wrong. Please try again.' };
        $("#evi-thinking").addClass("d-none");
        $("#evi-inputwrap").removeClass("d-none");
      }
    );
  }

  startPollingStatus(): void {
    if (!this.jobId) {
      return;
    }
    
    // Set uploadInProgress to true to start the loop
    this.uploadInProgress = true;

    this.pollingSubscription = interval(this.POLLING_INTERVAL).pipe(
      // switchMap cancels the previous observable (the HTTP request) if a new interval fires.
      switchMap(() => this.getJobStatus(this.jobId).pipe(
        // Handle any errors gracefully to prevent the stream from crashing
        catchError(() => {
          return of({ status: 'ERROR', error: true });
        })
      )),
      // takeWhile keeps the stream alive AS LONG AS the condition is TRUE.
      // We poll while this.uploadInProgress is TRUE.
      takeWhile(() => this.uploadInProgress, true), // The 'true' includes the last value before completion
      // finalize is called when the stream completes (i.e., when takeWhile condition fails)
      finalize(() => {})
    ).subscribe(
      (response: any) => {
        switch (response.status) {
          case 'started':
            this.jobStatus = { status: response.status, message: 'Your file has been received and is being prepared...' };
            break;
          case 'processing':
          case 'reading_document':
            this.jobStatus = { status: response.status, message: 'We&#39;re currently extracting data from your policy schedule. This process can take a moment, we appreciate your patience..' };
            break;
          case 'generating_quote':
            this.jobStatus = { status: response.status, message: 'We&#39;re preparing your personalised quote..' };
            break;
          case 'ready':
            this.jobStatus = { status: response.status, message: 'Your quote is ready. You can review it by clicking the button below.' };
            break;
          case 'password_required':
            this.jobStatus = { status: response.status, message: '' };
            this.pdfPasswordMessage = response?.errors?.[0]?.message || this.pdfPasswordMessage;
            this.pdfPasswordRequired = true;
            this.pdfPasswordInvalid = false;
            break;
          case 'invalid_password':
            this.pdfPasswordAttempts++;
            this.pdfPasswordMessage = response?.errors?.[0]?.message || this.pdfPasswordMessage;
            this.pdfPasswordRequired = true;
            this.pdfPasswordInvalid = true;
            this.jobStatus = { status: response.status, message: '' };
            break;
          case 'error':
            this.jobStatus = { status: response.status, message: 'Oh no! we seem to have encountered an error, please try your upload again.' };
            break;
        }

        const isTerminal = response.status === 'ready'
          || response.status === 'error'
          || response.status === 'password_required'
          || response.status === 'invalid_password'
          || response.error;

        if (isTerminal) {
          this.uploadInProgress = false;
          $("#evi-thinking").addClass("d-none");
          $("#evi-inputwrap").removeClass("d-none");
        }
      }
    );
  }
  getQuestions(class_id: number = 0, item_id: string = '0'): any {
    if (this.questions == null) {
      return [];
    }

    // Set status based on 'step'
  // this.currentStatus = Status.Conflict;
    if (this.step === 2) {
      this.currentStatus = Status.Missing;
    } else if (this.step >= 3) {
      this.currentStatus = Status.Review;
      
      return this.questions[this.currentStatus]?.filter(c => c.class_id === this.class_id && c.item_id === this.item_id);
    }

    //this.class_id = class_id;
    //this.item_id = item_id;
    //this.currentStatus = Status.Conflict;
    
    
    return this.questions[this.currentStatus]?.filter(c => c.class_id === this.class_id && c.item_id === this.item_id);
  
  }
  pageInfoSecton(type: string, status: string): string {
    if (status =='0') {
      return this.pageInfo?.find(p => p.entry_type === type && p.extraction_status == null)?.description || '';
    }
    return this.pageInfo?.find(p => p.entry_type === type && p.extraction_status == status)?.description || '';
  }
  getItems(class_id: number): any {
   // console.log("getItems class_id",class_id, this.step);
    // let currentStatus: Status = Status.Conflict; // Initialize it
    let array = [];
    // Determine the status based on the component's 'step' property
    if (this.step === 2) {
      this.currentStatus = Status.Missing;
      array = this.questions[this.currentStatus]?.filter(c => c.class_id === class_id);
    } else if (this.step >= 3) {
      this.currentStatus = Status.Review;
      array = this.questions[this.currentStatus]?.filter(c => c.class_id === class_id);
    }
    // console.log("currentStatus",this.currentStatus);
    
    // 1. Use map() to extract all item_id values into a new array.
    const itemMap = new Map<number, { item_id: number, description: string }>();

    for (const item of array) {
      // Only add the item if its item_id hasn't been added to the map yet (deduplication)
      if (!itemMap.has(item.item_id)) {
        itemMap.set(item.item_id, {
          item_id: item.item_id,
          description: item.description // Assuming 'description' is a property on the item object
        });
      }
    }

    // 3. Convert the Map values into a final array of objects.
    const distinctItemsWithDescription = Array.from(itemMap.values());

    // 4. Sort the final array by item_id
    distinctItemsWithDescription.sort((a, b) => {
      if (a.item_id < b.item_id) return -1;
      if (a.item_id > b.item_id) return 1;
      return 0;
    });

    return distinctItemsWithDescription;

  }
  showDiv(id: string, class_id: number, item_id: string = '0'): void {
    this.class_id = class_id;
    this.item_id = item_id;
    
    if (this.currentStatus === Status.Review ){
      //document.getElementById('edit-item-col')?.scrollIntoView({ behavior: 'smooth' });
      setTimeout(() => {
        document.querySelectorAll('.edit-modal__content-body').forEach((el: Element) => {
          const element = el as HTMLElement;
          element.style.scrollBehavior = 'smooth';
          element.scrollTop = 0;
        });
      }, 0);
    }
    //check for class_id = 0
    let classExist = this.questions[this.currentStatus].some(q => q.class_id === this.class_id);
    if (!classExist){
      this.class_id = this.questions[this.currentStatus][0]?.class_id;
      this.item_id = this.questions[this.currentStatus][0]?.item_id;
    }
    
    this.modalButton.text = 'Next';
    if (this.step === 2) {
      this.currentStatus  = Status.Missing;
    }
     if (this.step >= 3) {
       this.currentStatus = Status.Review;
       this.modalButton.disabled = false;
       this.modalButton.text = 'Continue';
    }
   
     $('#' + id).removeClass('d-none');
    //$('.item-trigger').removeClass('is-active');
  //  const itemTriggers = document.querySelectorAll('.item-trigger');

  //   // 2. Iterate over the resulting NodeList
  //   // Note: Use forEach() or a standard 'for...of' loop
  //   itemTriggers.forEach(element => {
  //       // 3. Remove the 'is-active' class from the element's class list
  //       console.log(element);
  //       element.classList.remove('is-active');
  //   });
  //   //
    //console.log( $('.item-trigger'))
    //console.log(this.questions[this.currentStatus][0])
    
    //$('#item-'+this.class_id+'-'+this.item_id).addClass('is-active');
    this.itemQuestions = this.questions[this.currentStatus].filter(c => c.class_id === this.class_id && c.item_id === this.item_id);
    //this.cdr.detectChanges();
  }
  onQuestionAnswerChange(event: any): void {
    const questionId = event.cent_aq_question_id;
  const originalAnswer = this.originalAnswers.get(questionId);
    if (event?.dependant_flow_id) {
      console.log(event);
     // const existing = this.questions?.[this.currentStatus]?.find((q: Question) => q.cent_aq_question_id === event?.cent_aq_question_id);
      //console.log(existing);
      originalAnswer !== undefined && originalAnswer !== event.answer
      if (originalAnswer && originalAnswer !== event.answer) {
        this.pendingDependentQuestion = event;
        this.pendingDependentOriginalAnswer = originalAnswer;
        $('#evi-modal-additional').modal('show');
      }
    }
    this.answerChangeSubject.next(event);
  }

  confirmStartDependentFlow(): void {
    if (this.pendingDependentQuestion) {
      this.startDependentFlow(this.pendingDependentQuestion);
      this.pendingDependentQuestion = null;
      this.pendingDependentOriginalAnswer = null;
      setTimeout(() => {
        const card = document.querySelector('.card__additional-inner') as HTMLElement;
        if (card) {
          card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    }
  }

  cancelDependentFlow(): void {
    if (this.pendingDependentQuestion && this.pendingDependentOriginalAnswer !== undefined) {
      const idx = this.questions?.[this.currentStatus]?.findIndex((q: Question) => q.cent_aq_question_id === this.pendingDependentQuestion?.cent_aq_question_id);
      if (idx > -1) {
        this.questions[this.currentStatus][idx] = { ...this.questions[this.currentStatus][idx], answer: this.pendingDependentOriginalAnswer };
        this.questions[this.currentStatus] = [...this.questions[this.currentStatus]];
        this.cdr.detectChanges();
      }
    }
    this.pendingDependentQuestion = null;
    this.pendingDependentOriginalAnswer = null;
    this.activeDependentQuestionId = -1;
    this.dependentFlowActive = false;
    this.dependentFlowDone = false;
    
    
  }
  resetQuestion(){
    this.dependentFlowActive = false;
    setTimeout(() => {
      document.getElementById(`demo-conflicting-item-${this.activeDependentQuestionId}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  }
  getChildrenQuestions(question: Question): Question[] {
    return this.dependentQuestions.filter(x => x?.parent_control === question?.cent_aq_question_id);
  }

  getITK(): void {
    if (!this.currentQuestion?.itk) { this.itk = ''; return; }
    let itk = '';
    try {
      const json = JSON.parse(this.currentQuestion.itk);
      itk = json.filter((item: any) => item.answer === this.currentQuestion?.answer)[0]?.itk_comment;
      if (!itk) {
        itk = json.filter((item: any) => item.answer_id === 0)[0]?.itk_comment;
      }
    } catch (e) { }
    this.itk = itk || '';
  }

  subQuestionResponse(event: any): void {
    if (this.answeredQuestions.find(q => q?.cent_aq_question_id === event?.cent_aq_question_id)) {
      this.answeredQuestions.find(q => q?.cent_aq_question_id === event?.cent_aq_question_id).answer = event.answer;
    } else {
      this.answeredQuestions.push(event);
    }
  }

  startDependentFlow(question: Question): void {
    this.activeDependentQuestionId = question?.cent_aq_question_id;
    this.dependentQuestions = [];
    this.answeredQuestions = [];
    this.currentQuestion = null;
    this.dependentFlowActive = false;
    this.dependentFlowDone = false;

    this.flowPlayer.flowQuestions(question?.dependant_flow_id, this.sessionDetails?.category_id, this.eviSessionId, this.sessionDetails?.group_id, question?.item_id)
      .subscribe((flowQuestions: Question[]) => {
        this.dependentQuestions = flowQuestions;
        this.currentQuestion = this.dependentQuestions.find(q => q?.flow_index === 1);
        if (this.currentQuestion) {
          this.currentQuestion.isEdit = true;
        }
        this.getITK();
        this.dependentFlowActive = true;
      });
  }

  nextDependentQuestion(): void {
    if (this.answeredQuestions.find(q => q?.cent_aq_question_id === this.currentQuestion?.cent_aq_question_id)) {
      this.answeredQuestions.find(q => q?.cent_aq_question_id === this.currentQuestion?.cent_aq_question_id).answer = this.currentQuestion.answer;
    } else {
      this.answeredQuestions.push(this.currentQuestion);
    }

    this.questionService.saveAnswer(this.eviSessionId, this.currentQuestion?.cent_aq_question_id, this.currentQuestion?.product_class_id, this.currentQuestion?.item_id, this.currentQuestion?.answer, this.currentQuestion?.answer_id, this.currentQuestion?.comment, this.currentQuestion?.flow_id)
      .subscribe(() => {});

    if (this.currentQuestion?.call_proc) {
      this.processing = true;
      this.questionService.runCommand(
        this.questionService.replaceCallProcParemeters(
          this.currentQuestion?.call_proc,
          this.currentQuestion.item_id,
          this.eviSessionId,
          this.currentQuestion?.class_id,
          this.currentQuestion?.page,
          this.currentQuestion?.flow_id,
          this.currentQuestion?.cent_aq_question_id,
          this.sessionDetails?.group_id,
          this.sessionDetails?.category_id
        )).subscribe((val: any[]) => {
          if (val?.length && val[0]?.next) {
            this.currentQuestion = this.dependentQuestions.find(q => q?.cent_aq_question_id === val[0].next);
            if (this.currentQuestion) this.currentQuestion.isEdit = true;
          }
          this.getITK();
          this.processing = false;
        });
    } else if (this.currentQuestion?.conditions) {
      try {
        const condition = JSON.parse(this.currentQuestion?.conditions)[0];
        if (condition.operator === '=' && this.currentQuestion?.answer === condition.answer_text) {
          this.currentQuestion = this.dependentQuestions.find(q => q?.cent_aq_question_id === condition?.next);
        } else {
          this.currentQuestion = this.dependentQuestions.find(q => q?.cent_aq_question_id === this.currentQuestion?.next);
        }
        if (this.currentQuestion) this.currentQuestion.isEdit = true;
      } catch { }
      this.getITK();
    } else {
      this.currentQuestion = this.dependentQuestions.find(q => q?.cent_aq_question_id === this.currentQuestion?.next);
      if (this.currentQuestion) this.currentQuestion.isEdit = true;
      this.getITK();
    }
  }

  prevDependentQuestion(): void {
    this.currentQuestion = this.dependentQuestions.find(q => q?.next === this.currentQuestion?.cent_aq_question_id);
    this.getITK();
  }

  dependantFlowDone(): void {
    this.processing = true;
    setTimeout(() => {
      this.dependentFlowDone = true;
      this.dependentFlowActive = false;
      this.processing = false;
    }, 500);
  }

  restartDependentFlow(): void {
    this.dependentFlowDone = false;
    this.dependentFlowActive = true;
    this.currentQuestion = this.dependentQuestions.find(q => q?.flow_index === 1);
    if (this.currentQuestion) this.currentQuestion.isEdit = true;
    this.getITK();
  }

  questionResponse(event: any): void {
    //console.log('Question response event:', event, this.selectedDetail);
    //console.log(this.getUnAnsweredQuestionCount(this.selectedDetail?.external_status_id));

    if (this.questions && this.questions[this.currentStatus]) {
      const q = this.questions[this.currentStatus].find(q => q.cent_aq_question_id === event.cent_aq_question_id);
      if (q) {
        q.answer = event.answer;
        q.response_parameters = JSON.stringify({ extraction_status: 1 });
      }
    }
    if (this.getUnAnsweredQuestionCount() > 0) {
      this.modalButton.disabled = true;
    } else {
      this.modalButton.disabled = false;
    }
    // Handle the question response as needed
  }
  getUnAnsweredQuestionCount( class_id: number = 0, item: string = '0'): number {
    let count = 0;
    
    //this.currentStatus = Status.Conflict;
    if (this.step === 2) {
      this.currentStatus = Status.Missing;
    }
    
    // Assuming 'questions' is an object where keys are status IDs and values are arrays of question objeScts
    if (this.questions && this.questions[this.currentStatus]) {
      count = this.questions[this.currentStatus]?.filter(q => !q.answer && (item === null || q.item_id == item) && q.class_id === class_id ).length;
    }
    if (this.step === 1 && this.currentStatus === Status.Conflict && count === 0 && this.mainMenu === false) {
      this.conflicting = false;
    }
     if (this.step === 2 && this.currentStatus === Status.Missing && count === 0 && this.mainMenu === false) {
      this.missing = false;
    }
    if (count === 0 && this.mainMenu === false) {
      this.modalButton.disabled = false;
      //this.modalButton.disabled = false;
    }
    // if (this.step === 3) {
    //   this.modalButton.disabled = true;
    // }
    return count;
  }
  allStepQuestionsAnswered(): boolean {
    this.currentStatus = Status.Conflict;
    if (this.step === 2) {
      this.currentStatus = Status.Missing;
    }
    if (this.step >= 3) {
      this.currentStatus = Status.Review;
    }
    return this.questions[this.currentStatus]?.filter(q => !q.answer).length === 0;
  }
  continue(): void {
    this.modalButton.text = 'Continue to quote';
    this.modalButton.disabled = true;
  
    if (this.allStepQuestionsAnswered()) {
    
      this.questions[this.currentStatus].forEach(q => {
        q.response_parameters =  JSON.stringify({ extraction_status: 1 });
        this.questionFlowSessionStore.update({
          session_id: this.eviSessionId,
          group_id: q?.group_id,
          question_id: q?.cent_aq_question_id,
          class_id: q?.class_id,
          item_id: q?.item_id,  
          flow_id: q?.flow_id
        });
        if (q.answer !== null && q.answer !== undefined) {

          this.questionService.saveAnswerOnly(q).subscribe(response => {
            // Handle the response if needed
          });
        }
      });
      
      this.step += 1;
      this.openGetStartedDemo(this.step);
      this.mainMenu = true;
     
      if (this.step === 4) {
        // all steps complete
        this.modalButton.text = 'Continue to quotes';
        this.modalButton.disabled = false;
      }
      if (this.step === 5) {
        const parameters = new Map<string, string>();
        parameters.set('session_id', this.eviSessionId);
       //parameters.set('session_id', '1654196811627');
        this.questionService.runCommandNew(`resumeFlow`, parameters).subscribe((flow) => {
          // this.router.navigateByUrl(`/${flow[0]?.url}`);
          let url = 'quote-pick-cover?session_id=' + this.eviSessionId + '&superflow_id=3&category_id=3&flow_id=32&group_id=3&class_id=10&item_id=1&question_id=57&css=personal'
          this.router.navigateByUrl(`/${url}`);
          this.initModalListeners().closeAIModal();

        })

      }
      
    }
    else {

      const nextQuestion = (this.questions?.[this.currentStatus] ?? [])
        .filter(q =>
          q.answer == null || (typeof q.answer === 'string' && q.answer.trim() === '')
        )
        .sort((a, b) => {
          // --- Primary Sort: class_id (NEW ORDER) ---
          const aClassNum = Number(a.class_id);
          const bClassNum = Number(b.class_id);

          const aClassIsNum = Number.isFinite(aClassNum);
          const bClassIsNum = Number.isFinite(bClassNum);

          let classSortResult;

          if (aClassIsNum && bClassIsNum) {
            classSortResult = aClassNum - bClassNum; // numeric sort
          } else {
            classSortResult = String(a.class_id).localeCompare(String(b.class_id)); // fallback string sort
          }

          // If class_id's are different, return the result immediately
          if (classSortResult !== 0) {
            return classSortResult;
          }

          // --- Secondary Sort: item_id (Only if class_id's are equal) ---
          const aNum = Number(a.item_id);
          const bNum = Number(b.item_id);
          const aIsNum = Number.isFinite(aNum);
          const bIsNum = Number.isFinite(bNum);

          if (aIsNum && bIsNum) {
            return aNum - bNum; // numeric sort
          }

          // Fallback string sort for item_id
          return String(a.item_id).localeCompare(String(b.item_id));
        })[0];
      this.class_id = nextQuestion.class_id;
      this.item_id = nextQuestion.item_id;
      this.showDiv('item-' + this.class_id + '-' + this.item_id, this.class_id, this.item_id);
      this.mainMenu = false;
    }

  }
  openGetStartedDemo(step) {
    this.demoAIContentQuestions.classList.remove("d-none")

    this.demoAIModalNav.classList.add("d-none")
    this.demoAIContentEdit.classList.add("d-none")


    if (step && step === 2) {
      // show heading 2
      document.getElementById("demo-ai-content-heading-1").classList.add("d-none");
      document.getElementById("demo-ai-content-heading-2").classList.remove("d-none");
      document.getElementById("demo-ai-content-heading-3").classList.add("d-none");
    } else if (step && step === 3) {
      // show heading 3
      document.getElementById("demo-ai-content-heading-1").classList.add("d-none");
      document.getElementById("demo-ai-content-heading-2").classList.add("d-none");
      document.getElementById("demo-ai-content-heading-3").classList.remove("d-none");
    }
     else if (step && step === 4) {
      // show heading 4
      document.getElementById("demo-ai-content-heading-1").classList.add("d-none");
      document.getElementById("demo-ai-content-heading-2").classList.add("d-none");
      document.getElementById("demo-ai-content-heading-3").classList.add("d-none");
      document.getElementById("demo-ai-content-heading-4").classList.remove("d-none");
      this.modalButton.text = 'Continue';
    }

  }
  resetQuestions(): void {
    this.itemQuestions = [];
    this.showDiv('item-conflicting-policyholder-details', 0, '0');
    this.mainMenu = false;
  }
  openReview(): void {
    this.currentStatus = Status.Review;
    this.loadQuestions();
    this.showDiv('item-conflicting-policyholder-details', 0, '0');
    this.mainMenu = false;
    this.demoAIContentQuestions?.classList.add("d-none")

    this.demoAIModalNav?.classList.remove("d-none")
    this.demoAIContentEdit?.classList.remove("d-none")

  }
  isActiveItem(class_id: number, item_id: string): boolean {
    return this.class_id === class_id && this.item_id === item_id;
  }
  openSidesheet(): void {
    $('#help-sidesheet').addClass('is-active');
  }
  openAdd(): void {
    this.initModalListeners().closeAIModal();
    this.router.navigateByUrl(`quote-wizard?session_id=${this.eviSessionId}&superflow_id=43&category_id=3&flow_id=123&group_id=3&class_id=0&item_id=0&question_id=3230&css=personal`);
    // document.getElementById('demo-ai-modal-nav')?.classList.remove('d-none');
    // document.getElementById('demo-ai-content-edit')?.classList.remove('d-none');
    // document.getElementById('demo-ai-content-questions')?.classList.add('d-none');
    // document.getElementById('demo-ai-modal-addnav')?.classList.remove('d-none');
    // document.getElementById('demo-ai-modal-infonav')?.classList.add('d-none');
    // document.getElementById('add-benefits-nav')?.classList.remove('d-none');
    // document.getElementById('demo-conflicting-items-nav')?.classList.add('d-none');
  }
 
}